export default __webpack_public_path__ + "98e70fe.png";